import { DEFAULT_FEATURES } from '@/config/features/featureFlags'
import { MarketEnum } from '@/config/tenants/types'

import type { TenantConfig } from '@/config/tenants/types'

// Default tenant configuration
export const DEFAULT_TENANT: TenantConfig = {
  id: 'mediq_dk',
  marketId: MarketEnum.mediq_dk,
  sapCatalogId: 'mediqdkProductCatalog',
  name: 'Default',
  marketSanity: ['dk-b2c', 'dk-b2b'],
  domains: ['localhost:3000', 'localhost'],
  languages: ['dk', 'en'],
  locale: 'da-DK',
  defaultLanguage: 'dk',
  currency: 'DKK',
  timezone: 'Europe/Copenhagen',
  countryCode: 'DK',
  countryName: 'Denmark',
  features: DEFAULT_FEATURES,
  dateFormat: 'yyyy-mm-dd',
  postalCodeLength: 4,
}
